module.exports = __webpack_public_path__ + "static/media/long-arrow-right.45b72e2c.svg";